angular.module("app").controller("AndroidPromoAppController", [
    '$scope',
    '$cookies',
    '$rootScope',
    '$timeout',
    '$q',
    'androidAppService',
    "logger",
    "errorHandler",
    'preloadedPageNames',
    'preloadedData',
    'settingsService',
    'pagesService',
    'preloadedOptions',
    'Utils',
    function ($scope, $cookies, $rootScope, $timeout, $q, androidAppService, logger, errorHandler, preloadedPageNames, preloadedData, settingsService, pagesService, preloadedOptions, Utils) {
        var settings = settingsService.getSettings();
        $scope.state = {};
        $scope.state.selectedLanguage = $rootScope.env.lang || $cookies.get("preferedLanguage") || settings.skin.defaultLang;
        $scope.addedMenus = {};
        var initialData;
        $scope.addingMenuName = "";
        $scope.languages = settings.skin.languages;
        $scope.uploadCache = {};
        $scope.iconContainer = {};
        $scope.tooltip = {
            "download_url": ""
        };
        $scope.backgroundContainer = {};
        var processingFields = ['title', 'content'];
        var comparingFields = ['title', 'content', 'isActive'];
        var optionFields = ['package_name', 'download_url', 'app_size', 'download_count'];
        $scope.options = angular.copy(preloadedOptions)|| {};
        var initialOptions = preloadedOptions || {};
        var isCalled = false;


        /**
         * Init page names
         */
        function initPageNames(pageNamesPrsponse) {
            $scope.pageNames = angular.copy(pageNamesPrsponse.pageNames);
            $scope.usedPageNames = {};
            pageNameTitleMap = {};
            var pageNamesLength = $scope.pageNames.length;
            for(var j = 0; j < pageNamesLength; ++j){
                var pageName =  $scope.pageNames[j];
                pageNameTitleMap[pageName.name] = pageName.title;
                if (pageNamesPrsponse.used.indexOf(pageName.id) !== -1){
                    $scope.usedPageNames[pageName.id] = true;
                }
                if ($scope.addedMenus[$scope.state.selectedLanguage]) {
                    var addedMenusLength = $scope.addedMenus[$scope.state.selectedLanguage].length;
                    for(var i = 0; i < addedMenusLength; ++i){
                        var addedPageName = $scope.addedMenus[$scope.state.selectedLanguage][i];
                        if (addedPageName.name === pageName.name) {
                            $scope.addedMenus[$scope.state.selectedLanguage][i] = pageName;
                            break;
                        }
                    }
                }
            }
        }
        initPageNames(preloadedPageNames);

        /**
         * Change menu item if it is not selected
         * @param menuItem
         */
        $scope.changeMenu = function (menuItem) {
            if (!$scope.activePage || menuItem.name !== $scope.activePage.name) {
                selectMenu(menuItem);
            }
        };

        function isChanged() {
            var promiseHandler = $q.defer();
            var isChanged = false;
            for (var i = comparingFields.length; i--;) {
                var key = comparingFields[i];
                if (initialData[key] !== $scope.activePage[key]) {
                    promiseHandler.resolve(true);
                    isChanged = true;
                    break;
                }
            }
            isChanged = isChanged || !angular.equals(initialData.images, $scope.activePage.images);
            isChanged = isChanged || !angular.equals(initialOptions[$scope.activePage.name], $scope.options[$scope.activePage.name]);
            if (!isChanged) {
                $scope.iconContainer.isChanged().then(function (isIconChanged) {
                    if (isIconChanged) {
                        promiseHandler.resolve(true);
                    } else {
                        $scope.backgroundContainer.isChanged().then(function (isBackgroundChanged) {
                            if (isBackgroundChanged) {
                                promiseHandler.resolve(true);
                            } else {
                                promiseHandler.resolve(false);
                            }
                        });
                    }

                })
            } else {
                promiseHandler.resolve(true);
            }

            return promiseHandler.promise;
        }

        function updateLogos() {
            $scope.iconContainer.update();
            $scope.backgroundContainer.update();
        }

        function getValueOrUndefined(value) {
            return !!value?value:undefined;
        }
        /**
         * Select menu item
         * @param menuItem
         */
        function selectMenu(menuItem) {
            $scope.calledCount = 0;
            $scope.imageToLoad = null;
            if ($scope.androidPromoAppForm) {
                $scope.androidPromoAppForm.$setUntouched();
            }
            $scope.isSavePressed = false;
            $scope.draggedImageDataUrl = $scope.draggedImage = undefined;
            if (initialOptions[menuItem.name]) {
                $scope.options[menuItem.name] = angular.copy(initialOptions[menuItem.name]);
            } else {
                $scope.options[menuItem.name] = {
                    package_name: "",
                    download_url: "",
                    app_size: "",
                };
            }
            if (menuItem.page) {
                $scope.activePage = angular.copy(menuItem.page);
                $scope.activePage.isActive = $scope.activePage.status === 'published';

                $scope.iconContainer.image = $scope.activePage.icon? $scope.activePage.icon: getValueOrUndefined(preloadedOptions[menuItem.name] && preloadedOptions[menuItem.name].icon);
                $scope.backgroundContainer.image = $scope.activePage.background? $scope.activePage.background: getValueOrUndefined(preloadedOptions[menuItem.name] && preloadedOptions[menuItem.name].background);
                $scope.activePage.images =  $scope.activePage.images || [];
                initialData = angular.copy($scope.activePage);
                if (isCalled) {
                    updateLogos();
                }

            } else {
                $scope.activePage = {
                    name: menuItem.name,
                    isActive: true,
                    title: "",
                    description: "",
                    images: []
                };
                $scope.iconContainer.image = getValueOrUndefined(preloadedOptions[menuItem.name] && preloadedOptions[menuItem.name].icon);
                $scope.backgroundContainer.image = getValueOrUndefined(preloadedOptions[menuItem.name] && preloadedOptions[menuItem.name].background);
                updateLogos();

            }
            isCalled = true;
            $rootScope.$broadcast("force:reset:editor");
        }

        function initMenu(pages) {
            $scope.menu = [];
            var pagesLength = pages.length;
            var isSelected = false;
            for(var i = 0; i < pagesLength; ++i){
                var page = pages[i];
                var item = {};
                item.id =  page.id;
                item.page = page;
                item.name = page.name;
                $scope.menu.push(item);
                if ($scope.activePage && page.name === $scope.activePage.name) {
                    selectMenu(item);
                    isSelected = true;
                }
            }
            var addedMenuseLength = $scope.addedMenus[$scope.state.selectedLanguage]? $scope.addedMenus[$scope.state.selectedLanguage].length: 0;
            for (var j = 0; j < addedMenuseLength; ++j){
                var pageName = $scope.addedMenus[$scope.state.selectedLanguage][j];
                var item  = {};
                item.name = pageName.name;
                $scope.menu.push(item);
                if ($scope.activePage && !isSelected && pageName.name === $scope.activePage.name) {
                    selectMenu(item);
                    isSelected = true;
                }
            }
            $scope.menu.sort(function (a, b) {
                return a.name.localeCompare(b.name);
            });
            if (!isSelected) {
                if ($scope.menu.length === 0) {
                    $scope.activePage = undefined;
                } else {
                    selectMenu($scope.menu[0]);
                }
            }
        }
        initMenu(preloadedData.items);

        /**
         * Update adding menu name chosen
         */
        $scope.updateAddingMenuChosen = function updateAddingMenuChosen() {
            $timeout(function () {
                $("#addingMenuName").trigger('chosen:updated');
            }, 50);
        };

        /**
         * Load selected language data
         */
        $scope.languageChangeHandler = function languageChangeHandler() {
            $scope.addmode = false;
            var filters = {
                lang: $scope.state.selectedLanguage,
                pageType: "android_promo_app",
                page_id: 0
            };
            $rootScope.env.lang = $scope.state.selectedLanguage;
            Utils.saveEnvToStorage();
            pagesService.getPagesNames(filters).then(
                function (pageNamesResponse) {
                    initPageNames(pageNamesResponse);
                    var pageFilters = {
                        lang: $scope.state.selectedLanguage
                    };
                    androidAppService.loadPromo(pageFilters).then(
                        function (pagesResponse) {
                            initMenu(angular.copy(pagesResponse.items));
                            $scope.updateAddingMenuChosen();
                        },
                        function (error) {
                            errorHandler(error.message);
                            return null
                        }
                    )
                },
                function (error) {
                    errorHandler(error.message);
                    return null
                }
            );
        };


        /**
         * Add menu item
         */
        $scope.addMenu = function addMenu() {
            var pageNamesLength = $scope.pageNames.length;
            for(var i = 0; i < pageNamesLength; ++i) {
                var pageName = $scope.pageNames[i];
                if ($scope.state.addingMenuName === pageName.name) {
                    $scope.addedMenus[$scope.state.selectedLanguage] = $scope.addedMenus[$scope.state.selectedLanguage] || [];
                    $scope.addedMenus[$scope.state.selectedLanguage].push(pageName);
                    var item  = {};
                    item.name = pageName.name;
                    $scope.menu.push(item);
                    break;
                }
            }
            $scope.menu.sort(function (a, b) {
                return a.name.localeCompare(b.name);
            });
            if (!$scope.activePage) {
                selectMenu($scope.menu[0]);
            }
            $scope.updateAddingMenuChosen();
            $scope.state.addingMenuName = "";
        };


        /**
         * Remove new added menu
         */
        $scope.removeMenu = function removeMenu(menu) {
            $scope.menu.splice($scope.menu.indexOf(menu), 1);
            $scope.addedMenus[$scope.state.selectedLanguage] = $scope.addedMenus[$scope.state.selectedLanguage].filter(function(item) {
                return item.name !== menu.name;
            });
            if ($scope.activePage.name === menu.name) {
                if($scope.menu.length > 0) {
                    selectMenu($scope.menu[0]);
                } else {
                    $scope.activePage = undefined;
                }
            }
            $scope.updateAddingMenuChosen();
        };


        $scope.$watch('uploadCache.image', function () {
            if ($scope.uploadCache.image && angular.isString($scope.uploadCache.image)) {
                $scope.activePage.images.push({
                    src: $scope.uploadCache.image
                });
                $scope.uploadCache.image = false;
            }
        });

        function checkAndSet(instance, source, key, previous) {
            if (source[key] && (!previous || previous[key] !== source[key])) {
                instance[key] = source[key];
            }
        }
        
        function createRequestData(id) {
            var promiseHandler = $q.defer();
            var request = {};
            processingFields.forEach(function (item) {
                checkAndSet(request, $scope.activePage, item, initialData);
            });
            var options = $scope.options[$scope.activePage.name];
            var previousOptions = initialOptions[$scope.activePage.name];
            optionFields.forEach(function (item) {
                checkAndSet(request, options, item, previousOptions);
            });

            var status = $scope.activePage.isActive? "published": "archive";
            request.images = $scope.activePage.images.filter(function (item) {
                return (item.src === null && item.id !== undefined) || (item.src !== null && item.src.indexOf('data:image') > -1);
            });
            if (id) {
                request.id = id;
                if ($scope.activePage.isActive !== initialData.isActive) {
                    request.status = status;
                }
                if (request.images.length === 0) {
                    delete request.images;
                }
            } else {
                request.lang = $scope.state.selectedLanguage;
                request.name = $scope.activePage.name;
                request.status = status;
            }


            $scope.iconContainer.buildResult(function (iconLogoData) {
                if (iconLogoData) {
                    request.icon = iconLogoData.image || null;
                }
                $scope.backgroundContainer.buildResult(function (backgroundLogoData) {
                    if (backgroundLogoData) {
                        request.background = backgroundLogoData.image || null;
                    }
                    promiseHandler.resolve(request);
                });
            });

            return promiseHandler.promise;
        }

        function addApp() {
            if (!$scope.androidPromoAppForm.$valid) {
                $scope.isSavePressed = true;
                return;
            } else {
                $scope.isSavePressed = false;
            }

            createRequestData().then(function (data) {
                androidAppService.savePromo(data).then(function (response) {
                        if (response.status == "ok") {
                            logger.logSuccess("global.saved");
                            initialOptions[$scope.activePage.name] = angular.copy($scope.options[$scope.activePage.name]);

                            $scope.addedMenus[$scope.state.selectedLanguage] = $scope.addedMenus[$scope.state.selectedLanguage].filter(function (item) {
                                return item.name !== $scope.activePage.name;
                            });
                            $scope.languageChangeHandler();
                        } else {
                            errorHandler(response.message)
                        }
                    },
                    function (response) {
                        errorHandler(response.message)
                    }
                )
            });
        }

        function editApp() {
            if (!$scope.androidPromoAppForm.$valid) {
                $scope.isSavePressed = true;
                return;
            } else {
                $scope.isSavePressed = false;
            }
            isChanged().then(function (result) {
                if (!result) {
                    logger.logError("global.no_changes");
                } else {
                    createRequestData($scope.activePage.id).then(function (data) {
                        androidAppService.savePromo(data).then(function (response) {
                                if (response.status == "ok") {
                                    logger.logSuccess("global.saved");
                                    initialOptions[$scope.activePage.name] = angular.copy($scope.options[$scope.activePage.name]);
                                    androidAppService.loadPromo({lang: $scope.state.selectedLanguage}).then(
                                        function (promoResponse) {
                                            var menuLength = $scope.menu.length;
                                            for (var i = 0; i < menuLength; ++i){
                                                var menu = $scope.menu[i];
                                                if (menu.name === $scope.activePage.name) {
                                                    var pagesLength = promoResponse.items.length;
                                                    for(var j = 0; j < pagesLength; ++j){
                                                        var page = promoResponse.items[j];
                                                        if(page.name === $scope.activePage.name) {
                                                            menu.page = page;
                                                            selectMenu(menu);
                                                            break;
                                                        }
                                                    }
                                                    break;
                                                }
                                            }
                                            $scope.updateAddingMenuChosen();
                                        },
                                        function (error) {
                                            errorHandler(error.message);
                                            return null
                                        }
                                    )


                                } else {
                                    errorHandler(response.message)
                                }
                            },
                            function (response) {
                                errorHandler(response.message)
                            }
                        )

                    });
                }
            })
        }

        $scope.save = function save() {
            if (!$scope.activePage.id) {
                addApp();
            } else {
                editApp();
            }
        }

        $scope.setForm = function setForm(formElement) {
            $scope.androidPromoAppForm = formElement;
        }
    }
]);
